export default "__VITE_ASSET__DvbRSo0p__"